import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDndnxsZ5Ur0RIYxeDA-pxkqrIAEVk-2uw",
  authDomain: "farmology-saas-87c43.firebaseapp.com",
  projectId: "farmology-saas-87c43",
  storageBucket: "farmology-saas-87c43.firebasestorage.app",
  messagingSenderId: "594879023548",
  appId: "1:594879023548:web:cd9bec49bbf739957a83b9",
  measurementId: "G-JW18VG6G4B",
};

let messaging;
try {
  const app = initializeApp(firebaseConfig);
  console.log("Firebase initialized successfully.");

  isSupported()
    .then((supported) => {
      if (supported) {
        messaging = getMessaging(app);
        console.log("Firebase Messaging supported and initialized.");
        // Handle foreground messages
        onMessage(messaging, (payload) => {
          console.log("Foreground message received:", payload);
        });
      } else {
        console.warn("Firebase Messaging is not supported in this browser.");
      }
    })
    .catch((error) => {
      console.error("Error checking Firebase Messaging support:", error);
    });
} catch (error) {
  console.error("Error initializing Firebase:", error);
}

// Register Service Worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log(
        "Service Worker registered successfully:",
        registration.scope
      );
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
} else {
  console.warn("Service Workers are not supported in this browser.");
}

// Error handler for ResizeObserver
if (window.ResizeObserver) {
  const resizeObserverErrorHandler = (e) => {
    if (e.message === "ResizeObserver loop limit exceeded") return;
    console.error("Unhandled ResizeObserver error:", e);
  };
  window.addEventListener("error", resizeObserverErrorHandler);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
